<!-- Main container -->
<div class="flex flex-col max-w-[var(--dsb-content-max-width)] min-h-screen relative mx-auto" qa="app-container">
    <!-- Title bar -->
    <app-title-bar
        (goBack)="onGoBack()"
        *ngIf="titleBarViewModel"
        [viewModel]="titleBarViewModel"
        class="z-6 bg-white px-lg pt-lg"
    ></app-title-bar>
    <!-- Main routed content -->
    <div class="w-full grow">
        <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
    </div>
</div>
